<template>
  <v-card
    id="high-volume-warning"
    class="mt-3"
  >
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          sm="auto"
        >
          <v-icon
            x-large
            class="px-5"
          >
            mdi-message-alert-outline
          </v-icon>
        </v-col>

        <v-col id="high-volume-warning-message">
          {{ $t('highVolumeWarning.message') }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'HighVolumeWarningBanner'
}
</script>

<style lang="scss" scoped>
#high-volume-warning {
  max-width: 800px;

  ::v-deep #high-volume-warning-message {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
